import { z } from 'zod';
import {
    floatingPointPrecisionSchema,
    PRODUCT_CATEGORY_SCHEMA,
    PRODUCT_TYPE_SCHEMA,
    SUPPORTED_UNITS_SCHEMA,
} from '@schuettflix/interfaces';
import { CurrencyCodeSchema } from '@schuettflix/utils';
import { AdditionalPropertiesDiscriminatorSchema } from '@/shared/models/ContextDataModel/interfaces/entities/properties.ts';
import { ProcessingTypeSchema } from '@/shared/models/ContextDataModel/interfaces/enums/processing-type.ts';

export const BaseProductConfigurationSchema = z.object({
    id: z.string().optional(),
    index: z.number().positive(),
    productType: PRODUCT_TYPE_SCHEMA,
    category: PRODUCT_CATEGORY_SCHEMA,
    isMainProduct: z.boolean(),
    productName: z.string(),
    quantity: floatingPointPrecisionSchema,
    unit: SUPPORTED_UNITS_SCHEMA,
    purchasePrice: z.number(),
    purchaseTaxClassId: z.string(),
    salesPrice: z.number(),
    salesTaxClassId: z.string(),
    currencyCode: CurrencyCodeSchema,
    salesforceOpportunityId: z.string().optional(),
    partnerOrganizationId: z.number().positive().nullable(),
    showZeroPurchasePrice: z.boolean(),
    showZeroSalesPrice: z.boolean(),
    processingType: ProcessingTypeSchema,
    salesQuantity: floatingPointPrecisionSchema,
    salesUnit: SUPPORTED_UNITS_SCHEMA,
    purchaseQuantity: floatingPointPrecisionSchema,
    purchaseUnit: SUPPORTED_UNITS_SCHEMA,
    salesforceOpportunityLineItemId: z.string().optional(),
    serviceDate: z.coerce.date().optional(),
});

export const ProductConfigurationSchema = z.object({
    ...BaseProductConfigurationSchema.shape,
    additionalProperties: AdditionalPropertiesDiscriminatorSchema,
});

export type ProductConfiguration = z.infer<typeof ProductConfigurationSchema>;
